import {useApi} from "@contexts/hooks/api/useApi.ts";
import {__usuarios_endpoints} from "@components/usuario/endpoints/__usuarios_endpoints.ts";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {IUsuario} from "@models/conta/IUsuario.ts";
import {IUsuarioFiltersDto} from "@models/conta/IUsuarioFiltersDto.ts";
import {IDataDto, IDataNoPageDto} from "@models/shared/IDataDto.ts";
import {IGetUsuarioFilter} from "@components/usuario/dto/request/IGetUsuarioFilter.ts";
import {ICreateUsuarioDto} from "@components/usuario/dto/input/ICreateUsuarioDto.ts";

export function useUsuario() {
    const {Get} = useApi();

    const tryGet = async (search: Pick<IUsuario, 'id'>) => {
        return await Get(__usuarios_endpoints.GetContas({
            ids: [search.id]
        }, {page: 1, pageSize: 1})).then(x => x.items[0]);
    }

    const getUsuarioById = async (id: number) => {
        return await Get(__usuarios_endpoints.GetContas({
            ids: [id]
        }, {page: 1, pageSize: 1})).then(x => x.items[0]);
    }

    const getUsuarioByEmail = async (email: string) => {
        return await Get(__usuarios_endpoints.GetContas({
            email: email
        }, {page: 1, pageSize: 1})).then(x => x.items[0]);
    }

    const getUsuariosOld = async (filters: IUsuarioFiltersDto, pagination: IPagination) => {
        return await Get(__usuarios_endpoints.GetContas(filters, pagination));
    }

    const getUsuarios = async (filters: IGetUsuarioFilter, pagination: IPagination) => {
        return await Get(__usuarios_endpoints.v2['get-usuarios']({data: filters, pagination: pagination}));
    }

    const importUsuarios = async (users: IDataNoPageDto<IUsuario[]>) => {
        return await Get(__usuarios_endpoints.ImportUsuarios(users));
    }

    const createUsuario = async (data: ICreateUsuarioDto) => {
        return await Get(__usuarios_endpoints.v2['create-usuario']({data: data}));
    }

    const getUsuarioLogs = async (data: IDataDto<{ usuarioId: number }>) => {
        return await Get(__usuarios_endpoints.v2["get-logs"](data));
    }

    const purgeCache = async () => {
        return await Get(__usuarios_endpoints.v2["purge-cache"]());
    }

    return {
        tryGet: tryGet,
        getUsuarioById: getUsuarioById,
        getUsuarioByEmail: getUsuarioByEmail,
        getUsuariosOld: getUsuariosOld,
        getUsuarios: getUsuarios,
        importUsuarios: importUsuarios,
        createUsuario: createUsuario,
        getUsuarioLogs: getUsuarioLogs,
        purgeCache: purgeCache
    };
}